import React, { useState, useEffect } from 'react';
import { useLanguage } from "../../contexts/LanguageContext";
import { useNavigate } from 'react-router-dom';
import { getApi, postApi } from '../../utils/api/api'; // Assuming getApi is used for fetching data
import { showToast } from '../../utils/toast';
import { useAuth } from '../../contexts/AuthContext';
import PasswordUpdateForm from './PasswordUpdateForm';
import PhoneInput from 'react-phone-input-2';
import importImage from "../../utils/images/importImage";
const ProfileForm = () => {
  const RegisterFormImage = importImage("login-form.jpg");
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { user, setUser } = useAuth(); // Access and update user data from AuthContext
  console.log("AuthUser::", user);
  // Initialize form data
  const [formData, setFormData] = useState({
    name: '',
    c_name: '',
    c_type: '',
    designation: '',
    email: '',
    phone_number: '',
    c_website: '',
    c_address: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Fetch profile data from API
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await getApi('/get-profile'); // API endpoint for fetching profile
        const { data } = response;
        console.log("Profile Form data::>", data);

        // Update form data and AuthContext
        setFormData({
          name: data.user.name || '',
          c_name: data.user.c_name || '',
          c_type: data.user.c_type || '',
          // designation: data.user.designation || '',
          email: data.user.email || '',
          phone_number: data.user.phone_number || '',
          c_website: data.user.c_website || '',
          c_address: data.user.c_address || '',
        });
      } catch (err) {
        showToast('error', t('errors.fetchProfileFailed', 'Failed to fetch profile data.'));
      }
    };

    fetchProfileData();
  }, [setUser, t]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: '' })); // Clear errors on input change
  };

   const handlePhoneChange = (value, countryData) => {
    const countryCode = countryData.dialCode;
    const phoneNumberWithoutPlus = value.startsWith('+') ? value.slice(1) : value;
    const fullNumber = phoneNumberWithoutPlus.startsWith(countryCode)
      ? phoneNumberWithoutPlus
      : `${countryCode}${phoneNumberWithoutPlus}`;
    setFormData({ ...formData, phone_number: fullNumber });
    setErrors((prev) => ({ ...prev, phone_number: '' }));
  };

  const validateForm = () => {
    const { name, c_name, c_type, designation,c_address } = formData;
    const newErrors = {};

    // Name validation
    if (!name.trim()) {
      newErrors.name = t('errors.nameRequired', 'Name is required.');
    }

    // Company Name validation
    if (!c_name.trim()) {
      newErrors.c_name = t('errors.companyNameRequired', 'Company name is required.');
    }

    // Company Type validation
    if (!c_type.trim()) {
      newErrors.c_type = t('errors.companyTypeRequired', 'Company type is required.');
    }

      if (!c_address.trim()) {
        newErrors.c_address = t('errors.companyAddressRequired');
      }


      
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    try {
      const userData = await postApi('/profile', formData); // Update profile API endpoint
      console.log('userData:: ', userData);
      if (userData?.success) {
        const storedUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        if (Object.keys(storedUser).length) {
          storedUser.user_data = userData?.data?.user;
          localStorage.setItem('user', JSON.stringify(storedUser))
          setUser(storedUser);
        }
        showToast('success', t('success.profileUpdated', 'Profile updated successfully.'));
      }
    } catch (err) {
      showToast('error', err.message || t('errors.profileUpdateFailed', 'Profile update failed.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="form-wrapper py-5" style={{ minHeight: '100vh' }}>
        <div className="container">
          {/* Header Section */}
          
          <div className='row g-4 justify-content-center'>
            {/* Main Profile Form Card */}
            <div className='col-lg-12'>
              <div className='card form-card pt-5' style={{ borderRadius: '15px', boxShadow: '0 4px 30px rgba(0,0,0,0.08)' }}>
                {/* Profile Details Heading with Icon */}
                {/* <h3 className='text-primary mb-4 d-flex align-items-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-person-fill me-3" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                  </svg>
                  {t('profileForm.formHeading', 'Profile Details')}
                </h3> */}
                <div className="text-center mb-5">
            <h1 className="display-4 fw-bold text-dark">{t('profileForm.heading', 'Edit Profile')}</h1>
            <p className="lead text-muted">{t('profileForm.subheading', 'Update your personal and company information.')}</p>
          </div>
                
                {/* Profile Picture Placeholder */}
                {/* <div className="text-center mb-4">
                  <div className="rounded-circle bg-light d-inline-block d-flex justify-content-center align-items-center" style={{ width: '120px', height: '120px', border: '2px solid #ced4da' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#6c757d" className="bi bi-person" viewBox="0 0 16 16">
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664z"/>
                    </svg>
                  </div>
                </div> */}

               
                  {/*<div className='row g-4'>
                    <div className='col-lg-6'>
                      <div className='form-group'>
                        <label className="form-label text-dark fw-bold">{t('profileForm.fields.name.label', 'Name')}</label>
                        <input
                          type="text"
                          name="name"
                          className='form-control bg-light px-4 py-2'
                          value={formData.name}
                          onChange={handleChange}
                          style={{ borderRadius: '8px', border: '1px solid #ced4da' }}
                        />
                        {errors.name && <small className="text-danger">{errors.name}</small>}
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <div className='form-group'>
                        <label className="form-label text-dark fw-bold">{t('profileForm.fields.companyName.label', 'Company Name')}</label>
                        <input
                          type="text"
                          name="c_name"
                          className='form-control bg-light px-4 py-2'
                          value={formData.c_name}
                          onChange={handleChange}
                          style={{ borderRadius: '8px', border: '1px solid #ced4da' }}
                        />
                        {errors.c_name && <small className="text-danger">{errors.c_name}</small>}
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <div className='form-group'>
                        <label className="form-label text-dark fw-bold">{t('profileForm.fields.companyType.label', 'Company Type')}</label>
                        <input
                          type="text"
                          name="c_type"
                          className='form-control bg-light px-4 py-2'
                          value={formData.c_type}
                          onChange={handleChange}
                          style={{ borderRadius: '8px', border: '1px solid #ced4da' }}
                        />
                        {errors.c_type && <small className="text-danger">{errors.c_type}</small>}
                      </div>
                    </div>
                    
                    <div className='col-lg-6'>
                      <div className='form-group'>
                        <label className="form-label text-dark fw-bold">{t('profileForm.fields.email.label', 'Email')}</label>
                        <input
                          type="email"
                          name="email"
                          className='form-control bg-light px-4 py-2'
                          value={formData.email}
                          onChange={handleChange}
                          disabled
                          style={{ borderRadius: '8px', border: '1px solid #ced4da' }}
                        />
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <div className='form-group'>
                        <label className="form-label text-dark fw-bold">{t('profileForm.fields.phone.label', 'Phone Number')}</label>
                        <input
                          type="text"
                          name="phone_number"
                          className='form-control bg-light px-4 py-2'
                          value={formData.phone_number}
                          onChange={handleChange}
                          disabled
                          style={{ borderRadius: '8px', border: '1px solid #ced4da' }}
                        />
                      </div>
                    </div>
                    <div className='col-lg-12 mt-4'>
                      <button type="submit" className='btn btn-primary w-100 py-3 fw-bold' disabled={loading} style={{ borderRadius: '8px', transition: 'background-color 0.3s ease' }}>
                        {loading ? t('buttons.saving', 'Saving...') : t('profileForm.submitButton', 'Update Profile')}
                      </button>
                    </div>
                  </div>*/}
                   <div className="row g-0 h-100">
                {/* Form Column */}
                <div className="col-lg-12 d-flex align-items-center">
                  <div className="card-body p-4 p-md-5">
                 

                    <form onSubmit={handleSubmit} className="needs-validation" noValidate>
                      <div className="row">
                        <div className="col-lg-12 mb-4">
                          <label htmlFor="name" className="form-label fw-semibold">
                            {t('register.nameLabel', 'Full Name')}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group has-validation">
                            <span className="input-group-text bg-light border-end-0">
                              <i className="bi bi-person text-muted"></i>
                            </span>
                            <input
                              id="name"
                              type="text"
                              name="name"
                              className={`form-control py-3 ${errors.name ? 'is-invalid' : ''}`}
                              placeholder={t('placeholders.name', 'Your full name')}
                              value={formData.name}
                              onChange={handleChange}
                              maxLength={245}
                              required
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <label htmlFor="c_name" className="form-label fw-semibold">
                            {t('register.companyNameLabel', 'Company Name')}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group has-validation">
                            <span className="input-group-text bg-light border-end-0">
                              <i className="bi bi-building text-muted"></i>
                            </span>
                            <input
                              id="c_name"
                              type="text"
                              name="c_name"
                              className={`form-control py-3 ${errors.c_name ? 'is-invalid' : ''}`}
                              placeholder={t('placeholders.companyName', 'Your company name')}
                              value={formData.c_name}
                              onChange={handleChange}
                              maxLength={245}
                              required
                            />
                            {errors.c_name && <div className="invalid-feedback">{errors.c_name}</div>}
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <label htmlFor="c_type" className="form-label fw-semibold">
                            {t('register.companyTypeLabel', 'Company Type')}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group has-validation">
                            <span className="input-group-text bg-light border-end-0">
                              <i className="bi bi-diagram-3 text-muted"></i>
                            </span>
                            <select
                              id="c_type"
                              name="c_type"
                              className={`form-control py-3 ${errors.c_type ? 'is-invalid' : ''}`}
                              value={formData.c_type}
                              onChange={handleChange}
                              required
                            >
                              <option value="">{t('register.selectCompanyType', 'Select Company Type')}</option>
                              <option value="Spinning">{t('register.companyTypeSpinning', 'Spinning')}</option>
                              <option value="Knitting">{t('register.companyTypeKnitting', 'Knitting')}</option>
                              <option value="Weaving">{t('register.companyTypeWeaving', 'Weaving')}</option>
                              <option value="Warp knitting">{t('register.companyTypeWarpKnitting', 'Warp knitting')}</option>
                              <option value="Wholesaler">{t('register.companyTypeWholesaler', 'Wholesaler')}</option>
                              <option value="Other">{t('register.companyTypeOther', 'Other')}</option>
                            </select>
                            {errors.c_type && <div className="invalid-feedback">{errors.c_type}</div>}
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <label htmlFor="c_website" className="form-label fw-semibold">
                            {t('register.companyWebsiteLabel', 'Company Website')}
                          </label>
                          <div className="input-group has-validation">
                            <span className="input-group-text bg-light border-end-0">
                              <i className="bi bi-globe text-muted"></i>
                            </span>
                            <input
                              id="c_website"
                              type="text"
                              name="c_website"
                              className="form-control py-3"
                              placeholder={t('placeholders.companyWebsite', 'https://example.com')}
                              value={formData.c_website}
                              onChange={handleChange}
                              maxLength={245}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <label htmlFor="c_address" className="form-label fw-semibold">
                            {t('register.companyAddressLabel', 'Company Address')}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group has-validation">
                            <span className="input-group-text bg-light border-end-0">
                              <i className="bi bi-geo-alt text-muted"></i>
                            </span>
                            <input
                              id="c_address"
                              type="text"
                              name="c_address"
                              className={`form-control py-3 ${errors.c_address ? 'is-invalid' : ''}`}
                              placeholder={t('placeholders.companyAddress', 'Company address')}
                              value={formData.c_address}
                              onChange={handleChange}
                              maxLength={245}
                              required
                            />
                            {errors.c_address && <div className="invalid-feedback">{errors.c_address}</div>}
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <label htmlFor="email" className="form-label fw-semibold">
                            {t('register.emailLabel', 'Email')}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group has-validation">
                            <span className="input-group-text bg-light border-end-0">
                              <i className="bi bi-envelope text-muted"></i>
                            </span>
                            <input
                              id="email"
                              type="email"
                              name="email"
                              className={`form-control py-3 ${errors.email ? 'is-invalid' : ''}`}
                              placeholder={t('placeholders.email', 'your@email.com')}
                              value={formData.email}
                              onChange={handleChange}
                              maxLength={245}
                              required
                              disabled
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <label htmlFor="phone_number" className="form-label fw-semibold">
                            {t('register.phoneLabel', 'Phone Number')}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group has-validation">
                            {/* <span className="input-group-text bg-light border-end-0">
                              <i className="bi bi-phone text-muted"></i>
                            </span> */}
                            <PhoneInput
                              inputProps={{
                                id: "phone_number",
                                name: "phone_number",
                                className: `form-control py-3 ${errors.phone_number ? 'is-invalid' : ''}`,
                                required: true,
                                disabled : true
                              }}
                              country={'id'}
                              value={formData.phone_number}
                              onChange={handlePhoneChange}
                              inputClass={`w-100 ${errors.phone_number ? 'is-invalid' : ''}`}
                              containerClass="w-100"
                            />
                            {errors.phone_number && <div className="invalid-feedback">{errors.phone_number}</div>}
                          </div>
                        </div>

                        <div className="col-12 mt-3">
                          <div className="d-grid">
                            <button type="submit" className='btn btn-primary w-100 py-3 fw-bold' disabled={loading} style={{ borderRadius: '8px', transition: 'background-color 0.3s ease' }}>
                        {loading ? t('buttons.saving', 'Saving...') : t('profileForm.submitButton', 'Update Profile')}
                      </button>
                          </div>
                        </div>

                        
                      </div>
                    </form>
                  </div>
                </div>

               
              </div>
                
              </div>
            </div>
            {/* Password Update Form */}
            <div className='col-lg-12'>
              <div className='card form-card  p-3 pt-5 h-100' style={{ borderRadius: '15px', boxShadow: '0 4px 30px rgba(0,0,0,0.08)' }}>
                 <PasswordUpdateForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileForm;
